import { useEffect } from "react";
import Head from "next/head";

import EverythingYouNeed from "@component/landing/kikoff_card/everything_you_need";
import Fair from "@component/landing/kikoff_card/fair";
import Faq from "@component/landing/kikoff_card/faq";
import Footer from "@component/landing/kikoff_card/footer";
import Hero from "@component/landing/kikoff_card/hero";
import LegalFootnotes from "@component/landing/kikoff_card/legal_footnotes";
import LikeDebitCard from "@component/landing/kikoff_card/like_a_debit_card";
import Perks from "@component/landing/kikoff_card/perks";
import Publishers from "@component/landing/kikoff_card/publishers";
import LandingFooter from "@component/layout/footer";
import LandingNav from "@component/layout/nav";
import analytics from "@util/analytics";

import styles from "./styles.module.scss";

export type Flow = "waitlist" | "signup";

function KikoffCardContainer({ flow }: { flow: Flow }) {
  useEffect(() => {
    analytics.only("Criteo").convert("Hybrid Intent");
  }, []);

  return (
    <>
      <Head>
        <title>Kikoff Secured Credit Card, banking that builds credit</title>
        <meta
          name="description"
          content="Get the best perks of a banking service and all the power of credit building."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kikoff.com/kikoff-card" />
      </Head>
      <div className={styles["kikoff-card-landing-page-body"]}>
        <div className={styles["kikoff-card-landing-page"]}>
          <LandingNav />
          <Hero flow={flow} />
          <Publishers />
          <LikeDebitCard />
          <Perks />
          <Fair />
          <EverythingYouNeed />
          <Footer flow={flow} />
          <Faq />
          <LandingFooter legalFootnotes={<LegalFootnotes />} />
        </div>
      </div>
    </>
  );
}

export default KikoffCardContainer;
